import { marqueeItems } from "@/data/site";

export const Marquee = ({ dark = true }) => {
  const row = [...marqueeItems, ...marqueeItems];
  return (
    <section
      className={`py-5 sm:py-6 overflow-hidden border-y ${dark ? "bg-ink text-ivory border-transparent" : "bg-ivory text-ink hairline"}`}
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={`${item}-${i < row.length / 2 ? "a" : "b"}`} className="flex items-center whitespace-nowrap">
            <span className="font-display italic text-2xl sm:text-3xl px-8">{item}</span>
            <span className={`text-lg ${dark ? "text-goldtan" : "text-ink/30"}`}>✳</span>
          </span>
        ))}
      </div>
    </section>
  );
};
